import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }
const _hoisted_3 = { class: "assets-grid-card" }
const _hoisted_4 = { class: "assets-grid-card__header" }
const _hoisted_5 = { class: "assets-grid-title" }
const _hoisted_6 = { class: "assets-grid-title__text" }
const _hoisted_7 = { class: "text-muted small" }
const _hoisted_8 = { class: "assets-grid-controls" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "assets-grid-card__body" }
const _hoisted_11 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_12 = {
  key: 1,
  class: "wp-loading"
}
const _hoisted_13 = { class: "wp-loading__text" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 0,
  class: "alert alert-info d-flex align-items-center gap-2 mb-3"
}
const _hoisted_16 = {
  key: 0,
  class: "scheme-panel"
}
const _hoisted_17 = { class: "scheme-panel__header" }
const _hoisted_18 = { class: "scheme-panel__title" }
const _hoisted_19 = {
  key: 0,
  class: "alert alert-danger py-1 px-2 mb-2 small"
}
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = {
  value: null,
  disabled: ""
}
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_25 = { class: "mb-2" }
const _hoisted_26 = { class: "form-label d-block mb-1 required" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_29 = { class: "mb-2" }
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_32 = { class: "mb-2" }
const _hoisted_33 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_34 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_35 = { class: "scheme-editor__panel-hint" }
const _hoisted_36 = {
  key: 1,
  class: "alert alert-danger py-1 px-2 mb-0 small"
}
const _hoisted_37 = {
  key: 1,
  class: "scheme-panel"
}
const _hoisted_38 = { class: "scheme-panel__header" }
const _hoisted_39 = { class: "scheme-panel__title" }
const _hoisted_40 = {
  key: 0,
  class: "alert alert-danger py-1 px-2 mb-2 small"
}
const _hoisted_41 = {
  key: 1,
  class: "alert alert-warning py-1 px-2 mb-2 small"
}
const _hoisted_42 = {
  key: 2,
  class: "alert alert-danger py-1 px-2 mb-2 small"
}
const _hoisted_43 = {
  key: 3,
  class: "row g-2 mb-2"
}
const _hoisted_44 = { class: "col-6" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_47 = { class: "col-6" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_51 = {
  key: 1,
  class: "bi bi-upload me-1"
}
const _hoisted_52 = { class: "mb-2" }
const _hoisted_53 = { class: "form-label d-block mb-1" }
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "mb-2" }
const _hoisted_56 = { class: "form-label d-block mb-1" }
const _hoisted_57 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_58 = { class: "scheme-editor__panel-hint" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_61 = {
  key: 0,
  class: "assets-grid-card__body border-top"
}
const _hoisted_62 = { class: "d-flex justify-content-end" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SchemeEditor = _resolveComponent("SchemeEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
              _createElementVNode("i", { class: "bi bi-diagram-3-fill" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.isDraft ? _ctx.$t('components.infrastructure.anchorPlacement.addScheme') : (_ctx.scheme?.name || _ctx.$t('components.assetSchemes.editor.title'))), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.isDraft ? _ctx.displayGroupName : (_ctx.scheme?.group?.name || '-')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              title: _ctx.$t('common.back'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'AssetSchemes' })))
            }, [
              _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.back')), 1)
            ], 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[18] || (_cache[18] = _createElementVNode("span", {
                  class: "spinner-border wp-loading__spinner",
                  role: "status"
                }, null, -1)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('components.assetSchemes.loading')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (!_ctx.canEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[19] || (_cache[19] = _createElementVNode("i", { class: "bi bi-info-circle-fill" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetSchemes.editor.readOnly')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_SchemeEditor, {
                  ref: "editorRef",
                  "scheme-image": _ctx.schemeImage,
                  markers: _ctx.schemeMarkers,
                  assets: _ctx.assetsForGroup,
                  anchors: _ctx.anchors,
                  "initial-mode": _ctx.initialMode,
                  "read-only": !_ctx.canEdit,
                  calibration: _ctx.isDraft ? { widthM: _ctx.calibrationForm.widthM, heightM: _ctx.calibrationForm.heightM } : { widthM: _ctx.scheme?.widthM ?? null, heightM: _ctx.scheme?.heightM ?? null }
                }, _createSlots({ _: 2 }, [
                  (_ctx.canEdit)
                    ? {
                        name: "side-top",
                        fn: _withCtx(() => [
                          (_ctx.isDraft)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _cache[20] || (_cache[20] = _createElementVNode("i", { class: "bi bi-diagram-3-fill scheme-panel__icon" }, null, -1)),
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.addScheme')), 1)
                                ]),
                                (_ctx.errorMessage)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.errorMessage), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["form-label d-block mb-1", { required: !_ctx.presetGroupId }])
                                  }, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.form.location')), 3),
                                  (!_ctx.presetGroupId)
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 0,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.draftGroupId) = $event)),
                                        class: _normalizeClass(["form-select form-select-sm w-100", { 'is-invalid': _ctx.formTouched && !_ctx.draftGroupId }])
                                      }, [
                                        _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.form.locationPlaceholder')), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationOptions, (loc) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: loc.id,
                                            value: loc.id
                                          }, _toDisplayString(loc.name), 9, _hoisted_22))
                                        }), 128))
                                      ], 2)), [
                                        [
                                          _vModelSelect,
                                          _ctx.draftGroupId,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    : (_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: "text",
                                        class: "form-control form-control-sm w-100",
                                        value: _ctx.displayGroupName,
                                        disabled: ""
                                      }, null, 8, _hoisted_23)),
                                  (_ctx.formTouched && !_ctx.presetGroupId && !_ctx.draftGroupId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.form.locationRequired')), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.form.name')), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.draftName) = $event)),
                                    type: "text",
                                    class: _normalizeClass(["form-control form-control-sm w-100", { 'is-invalid': _ctx.formTouched && !_ctx.draftName.trim() }]),
                                    maxlength: "255",
                                    placeholder: _ctx.$t('components.infrastructure.anchorPlacement.form.namePlaceholder')
                                  }, null, 10, _hoisted_27), [
                                    [_vModelText, _ctx.draftName]
                                  ]),
                                  (_ctx.formTouched && !_ctx.draftName.trim())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.form.nameRequired')), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("input", {
                                  ref: "draftFileInputRef",
                                  type: "file",
                                  accept: "image/jpeg,image/png,image/webp,image/gif",
                                  hidden: "",
                                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDraftFileChange && _ctx.onDraftFileChange(...args)))
                                }, null, 544),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "tab-link active w-100 text-center mb-2",
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.triggerDraftFilePicker && _ctx.triggerDraftFilePicker(...args)))
                                }, [
                                  _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-upload me-1" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.draftFile ? _ctx.draftFile.name : _ctx.$t('components.infrastructure.anchorPlacement.form.file')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["form-label d-block mb-1", { required: !_ctx.draftFile }])
                                  }, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.widthM')), 3),
                                  _createElementVNode("input", {
                                    value: _ctx.calibrationForm.widthM,
                                    type: "number",
                                    step: "0.1",
                                    min: "0",
                                    class: _normalizeClass(["form-control form-control-sm w-100", { 'is-invalid': _ctx.formTouched && (!_ctx.draftFile ? !(_ctx.calibrationForm.widthM > 0) : !_ctx.isCalibrationValid) }]),
                                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onWidthInput($event)))
                                  }, null, 42, _hoisted_30),
                                  (_ctx.formTouched && !_ctx.draftFile && !(_ctx.calibrationForm.widthM > 0))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.form.widthRequired')), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("label", {
                                    class: _normalizeClass(["form-label d-block mb-1", { required: !_ctx.draftFile }])
                                  }, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.heightM')), 3),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.calibrationForm.heightM) = $event)),
                                    type: "number",
                                    step: "0.1",
                                    min: "0",
                                    class: _normalizeClass(["form-control form-control-sm w-100", { 'is-invalid': _ctx.formTouched && (!_ctx.draftFile ? !(_ctx.calibrationForm.heightM > 0) : !_ctx.isCalibrationValid) }])
                                  }, null, 2), [
                                    [
                                      _vModelText,
                                      _ctx.calibrationForm.heightM,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  (_ctx.formTouched && !_ctx.draftFile && !(_ctx.calibrationForm.heightM > 0))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t('components.infrastructure.anchorPlacement.form.heightRequired')), 1))
                                    : (_ctx.formTouched && _ctx.draftFile && !_ctx.isCalibrationValid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.errors.bothRequired')), 1))
                                      : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.draftFile ? _ctx.$t('components.infrastructure.anchorPlacement.form.dimensionsHintWithFile') : _ctx.$t('components.infrastructure.anchorPlacement.form.dimensionsHint')), 1),
                                (_ctx.createError)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.createError), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _cache[22] || (_cache[22] = _createElementVNode("i", { class: "bi bi-aspect-ratio scheme-panel__icon" }, null, -1)),
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.title')), 1)
                                ]),
                                (_ctx.calibrationError)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.calibrationError), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.scheme?.widthM == null && _ctx.hasAnchorMarkers)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.existingAnchorsWarning')), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.imageError)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.imageError), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                  ref: "imageFileInputRef",
                                  type: "file",
                                  accept: "image/jpeg,image/png,image/webp,image/gif",
                                  hidden: "",
                                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onImageFileChange && _ctx.onImageFileChange(...args)))
                                }, null, 544),
                                (_ctx.scheme?.filePath)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "tab-link tab-link--compact active w-100 text-center",
                                          disabled: _ctx.imageSaving,
                                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.triggerImagePicker && _ctx.triggerImagePicker(...args)))
                                        }, [
                                          (_ctx.imageSaving)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_46))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.changeImage')), 1)
                                        ], 8, _hoisted_45)
                                      ]),
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "tab-link tab-link--compact tab-link--danger w-100 text-center",
                                          disabled: _ctx.imageSaving,
                                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)))
                                        }, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.removeImage')), 9, _hoisted_48)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 4,
                                      type: "button",
                                      class: "tab-link active w-100 text-center mb-2",
                                      disabled: _ctx.imageSaving,
                                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.triggerImagePicker && _ctx.triggerImagePicker(...args)))
                                    }, [
                                      (_ctx.imageSaving)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_50))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_51)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.uploadImage')), 1)
                                    ], 8, _hoisted_49)),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.widthM')), 1),
                                  _createElementVNode("input", {
                                    value: _ctx.calibrationForm.widthM,
                                    type: "number",
                                    step: "0.1",
                                    min: "0",
                                    class: _normalizeClass(["form-control form-control-sm w-100", { 'is-invalid': _ctx.formTouched && !_ctx.isCalibrationValid }]),
                                    onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onWidthInput($event)))
                                  }, null, 42, _hoisted_54)
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.heightM')), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.calibrationForm.heightM) = $event)),
                                    type: "number",
                                    step: "0.1",
                                    min: "0",
                                    class: _normalizeClass(["form-control form-control-sm w-100", { 'is-invalid': _ctx.formTouched && !_ctx.isCalibrationValid }])
                                  }, null, 2), [
                                    [
                                      _vModelText,
                                      _ctx.calibrationForm.heightM,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  (_ctx.formTouched && !_ctx.isCalibrationValid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.errors.bothRequired')), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.widthLocksHeight')), 1),
                                (_ctx.scheme?.widthM != null)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 5,
                                      type: "button",
                                      class: "tab-link tab-link--compact tab-link--outline-danger w-100 mt-1 text-center",
                                      disabled: _ctx.clearingCalibration,
                                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clearCalibration && _ctx.clearCalibration(...args)))
                                    }, [
                                      (_ctx.clearingCalibration)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_60))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetSchemes.editor.calibration.clear')), 1)
                                    ], 8, _hoisted_59))
                                  : _createCommentVNode("", true)
                              ]))
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["scheme-image", "markers", "assets", "anchors", "initial-mode", "read-only", "calibration"])
              ]))
        ]),
        (_ctx.canEdit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("button", {
                  type: "button",
                  class: "tab-link active",
                  disabled: _ctx.saving || _ctx.creatingScheme,
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                }, [
                  (_ctx.saving || _ctx.creatingScheme)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.save')), 1)
                ], 8, _hoisted_63)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}